import React, { createContext, useState, useMemo } from 'react';
import { CLI_PUB } from '../environments/environment';
import * as CryptoJS from "crypto-js";
import { render } from '../utils/render';

const AuthContext = createContext({ auth: {}, setAuth: () => { } });

let activedata = localStorage.getItem('token') ? JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('token'), render(CLI_PUB)).toString(CryptoJS.enc.Utf8)) : null;
const AuthContextProvider = ({ children }) => {
    const [auth, setAuth] = useState(activedata ? activedata : null);
    const value = useMemo(() => ({ auth, setAuth }), [auth]);
    return (<AuthContext.Provider value={value}>{children}</AuthContext.Provider>);
};

const AuthContextConsumer = AuthContext.Consumer;
export { AuthContext, AuthContextProvider, AuthContextConsumer, };
